import { NeuCard } from "@neutron/react";import React from "react";

/** Thin wrapper around `<NeuCard`> */
export function Card(props: { children?: React.ReactNode, className?: string }) {
    return (
        <NeuCard className={props.className}>
            {props.children}
        </NeuCard>
    )
}

/**
 * Thin wrapper around `<NeuCardHeader>`
 * @NeutronUpdate Will need to replace `<NeuCardHeader>` with `<NeuCard unit="header">`
 */
export function CardHeader(props: { children?: React.ReactNode, className?: string }) {
    return (
        <NeuCard unit="header" className={props.className}>
            {props.children}
        </NeuCard>
    )
}

/**
 * Thin wrapper around `<NeuCardContent>`
 * @NeutronUpdate Will need to replace `<NeuCardContent>` with `<NeuCard unit="content">`
 */
export function CardContent(props: { children?: React.ReactNode, className?: string, center?: boolean }) {
    return (
        <NeuCard unit="content" className={`${props.className} ${props.center ? "neu-card-content--center" : ""}`}>
            {props.children}
        </NeuCard>
    )
}

export function CardActions(props: { children?: React.ReactNode, className?: string, right?: boolean }) {
    return (
        <NeuCard unit="footer" className={`${props.className} ${props.right ? "text-end" : ""}`} >
            {props.children}
        </NeuCard>
    )
}



